// Calendar ranges for the "Diese Woche / Letzte Woche / …" quick picks next to a
// Von–Bis pair. Weeks run Monday to Sunday.
export function presetRange(preset, today) {
  const monday = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() - ((today.getDay() + 6) % 7),
  )
  const shiftDays = (date, days) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate() + days)

  switch (preset) {
    case "last_week":
      return [shiftDays(monday, -7), shiftDays(monday, -1)]
    case "this_month":
      return [
        new Date(today.getFullYear(), today.getMonth(), 1),
        new Date(today.getFullYear(), today.getMonth() + 1, 0),
      ]
    case "last_month":
      return [
        new Date(today.getFullYear(), today.getMonth() - 1, 1),
        new Date(today.getFullYear(), today.getMonth(), 0),
      ]
    default:
      return [monday, shiftDays(monday, 6)]
  }
}

// Local date parts, not toISOString(): that converts to UTC and lands a day early.
export function isoDate(date) {
  const pad = (value) => String(value).padStart(2, "0")
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

// Writes the ISO value into a date picker's hidden input; the change event makes the
// picker redraw its visible German text from it.
export function setPickerDate(input, date) {
  input.value = isoDate(date)
  input.dispatchEvent(new Event("change", { bubbles: true }))
}
